<template>
  <div>
    <p v-if="searchQuery" style="text-align: left;">
      {{ $t('search.results_for') }} "<b>{{ searchQuery }}</b>"&nbsp;|&nbsp;<a href="/search">{{ $t('buttons.clear') }}</a>
    </p>
    <el-divider />
    <div class="posts-grid">
      <PostCardComponent 
        v-for="edge in posts.edges" 
        :key="edge.node.id" 
        :post="edge.node" 
        :isShort="edge.node.id === 5" 
      />
      <div v-if="posts.pageInfo.hasNextPage && posts.edges.length > 0" class="load-more-container">
        <button @click="loadMorePosts" class="btn btn--primary btn-wide btn--large">
          {{ $t('buttons.load_more') }}
        </button>
      </div>
    </div>
    <EmptyComponent v-if="!loading && posts.edges.length === 0" />
  </div>
</template>

<script>
import apolloClient from '@/services/apollo-client';
import { ref, onMounted, reactive } from 'vue';
import PostCardComponent from '@/components/Posts/PostCardComponent.vue';
import { GET_CURSOR_PAGINATED_POSTS } from '@/graphql/posts';
import EmptyComponent from '@/components/EmptyComponent.vue';

export default {
  name: 'SearchPage',
  components: {
    PostCardComponent,
    EmptyComponent,
  },
  setup() {
    const postsPerPage = parseInt(process.env.VUE_APP_POSTS_PER_PAGE) || 12;
    const posts = reactive({ edges: [], pageInfo: { hasNextPage: false, endCursor: null } });
    const loading = ref(false);
    const error = ref(null);
    const searchQuery = ref('');

    const fetchPosts = async (first = postsPerPage, after = null, search = '') => {
      loading.value = true;
      try {
        const { data } = await apolloClient.query({
          query: GET_CURSOR_PAGINATED_POSTS,
          variables: { first, after, search },
        });

        if (after) {
          posts.edges = [...posts.edges, ...data.cursorPaginatedPosts.edges];
        } else {
          posts.edges = data.cursorPaginatedPosts.edges;
        }
        posts.pageInfo = data.cursorPaginatedPosts.pageInfo;
      } catch (err) {
        error.value = err;
        console.error('Error fetching posts:', err);
      } finally {
        loading.value = false;
      }
    };

    const loadMorePosts = async () => {
      if (posts.pageInfo.hasNextPage) {
        await fetchPosts(postsPerPage, posts.pageInfo.endCursor, searchQuery.value);
      }
    };

    const parseSearchQuery = () => {
      const params = new URLSearchParams(window.location.search);
      searchQuery.value = params.get('s') || '';
    };

    onMounted(async () => {
      parseSearchQuery();
      await fetchPosts(postsPerPage, null, searchQuery.value);
    });

    return {
      posts,
      loading,
      error,
      searchQuery,
      loadMorePosts,
    };
  },
};
</script>

<style scoped>
.posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.load-more-container {
  grid-column: 1 / -1;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  position: relative;
  z-index: 1;
}

.load-more-container button {
  width: 100%;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .posts-grid {
    padding: 15px;
    gap: 20px;
  }
}
</style>
